/**
 * Utility functions for working with room/accommodation images
 */

/**
 * Get the first image for a room. Merges per-room and property-shared folders.
 */
export function getRoomMainImage(room, allImages) {
  const imgs = getRoomImages(room, allImages);
  return imgs.length > 0 ? imgs[0].url : null;
}

/**
 * Get all images for a room. Returns room-specific images first (from
 * room.photos_storage_path) followed by property-shared images (from
 * room.shared_photos_storage_path), so common spaces and identical fixtures
 * don't need to be uploaded into every room folder.
 */
export function getRoomImages(room, allImages) {
  if (!room || !allImages?.length) return [];
  const roomImages = room.photos_storage_path
    ? allImages.filter(img => img.category === room.photos_storage_path)
    : [];
  const sharedImages = room.shared_photos_storage_path
    ? allImages.filter(img => img.category === room.shared_photos_storage_path)
    : [];
  return [...roomImages, ...sharedImages];
}

/**
 * Get image count for a room
 * @param {Object} room - Room object with photos_storage_path
 * @param {Array} allImages - Array of all images loaded from backend
 * @returns {number} - Number of images for this room
 */
export function getRoomImageCount(room, allImages) {
  return getRoomImages(room, allImages).length;
}
